import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

export var MODULE_ID_SEPARATOR = '::';
export var FIRST_MODULE_ID = '@@TOP';
export var toSiblingMap = function toSiblingMap() {
  var siblingSelectors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return siblingSelectors.reduce(function (acc, it) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, it.key.join(MODULE_ID_SEPARATOR), it));
  }, {});
};
/* eslint-disable-next-line */

export var __example__devModuleIds = ['palette', 'spacingOverride'];
/* eslint-disable-next-line */

export var __example__siblingSpacing = [{
  key: [FIRST_MODULE_ID, 'breadcrumb'],
  spacing: [{}, {
    paddingTop: 'sm'
  }]
}, {
  key: [FIRST_MODULE_ID, 'cta'],
  spacing: [{}, {
    paddingTop: 'sm'
  }, {}]
}, {
  key: [FIRST_MODULE_ID, 'authorProfile'],
  spacing: [{}, {
    paddingTop: 'xl'
  }]
}, {
  key: ['hero', 'paragraph'],
  spacing: [{
    marginBottom: ['lg', 'xl']
  }, {}]
}, {
  key: ['button', 'widgetHtml'],
  spacing: [{
    paddingTop: ['md', 'xl']
  }, {}]
}, {
  key: ['hero', 'collectionModule'],
  spacing: [{}, {
    paddingTop: ['md', 'lg'],
    paddingBottom: ['md', 'lg']
  }]
}, {
  key: ['@@TOP', 'embedded-asset-block'],
  spacing: [{}, {
    paddingTop: ['lg', 'xl']
  }]
}, {
  key: ['imageModule', 'richTextModule'],
  spacing: [{}, {
    paddingTop: ['sm', 'md']
  }]
}, {
  key: ['imageModule', 'richTextBlock'],
  spacing: [{
    paddingBottom: ['sm', 'md']
  }, {}]
}, {
  key: ['heading-1', 'leadCaptureForm'],
  spacing: [{}, {
    paddingTop: 'md',
    paddingBottom: 'md'
  }]
}, {
  key: ['collectionModule', 'categoryGuidesModule'],
  spacing: [{
    paddingBottom: ['lg', 'xl']
  }, {
    paddingTop: ['lg', 'xl']
  }]
}, {
  key: ['contentHeroModule', 'heading-2'],
  spacing: [{
    marginBottom: ['lg', 'xl']
  }, {}]
}, {
  key: ['readMoreModule', 'author'],
  spacing: [{}, {
    paddingTop: 24
  }]
}, {
  key: ['categoryHeadingModule', 'authorProfile'],
  spacing: [{}, {
    paddingTop: 64
  }]
}, {
  key: ['categoryGuidesModule', 'categoryGuidesModule'],
  spacing: [{
    paddingTop: ['md', 'lg'],
    paddingBottom: ['md', 'xl']
  }, {}]
}, {
  key: ['categoryHeadingModule', 'categoryGuidesModule'],
  spacing: [{}, {
    paddingTop: 32,
    paddingBottom: 32
  }]
}, {
  key: ['linkList', 'categoryGuidesModule'],
  // eslint-disable-next-line no-magic-numbers
  spacing: [{
    paddingBottom: [32, 88]
  }, {}]
}, {
  key: ['linkWithLabel', 'accordion'],
  spacing: [{
    paddingBottom: 200
  }, {
    paddingTop: 200
  }]
}, {
  key: ['breadcrumb', 'linkWithLabel'],
  spacing: [{
    paddingBottom: 200
  }, {
    paddingTop: 200
  }]
}, {
  key: ['categoryHeadingModule', 'callOut'],
  spacing: [{}, {
    paddingTop: 'xs'
  }]
}, {
  key: ['callOut', 'productTable'],
  spacing: [{
    paddingBottom: 'md'
  }]
}, {
  key: ['hero', 'richTextModule'],
  spacing: [{}, {
    paddingTop: 'md'
  }]
}, {
  key: ['imageModule', 'paragraph'],
  spacing: [{
    marginBottom: 'md'
  }, {}]
}, {
  key: ['imageModule', 'heading-1'],
  spacing: [{
    marginBottom: 'base'
  }, {}]
}, {
  key: ['imageModule', 'heading-4'],
  spacing: [{
    marginBottom: 'base'
  }, {}]
}, {
  key: ['imageModule', 'heading-5'],
  spacing: [{
    marginBottom: 'base'
  }, {}]
}, {
  key: ['imageModule', 'heading-6'],
  spacing: [{
    marginBottom: 'base'
  }, {}]
}, {
  key: ['heading-3', 'imageModule'],
  spacing: [{
    mb: 'md'
  }, {}]
}, {
  key: ['table', 'richTextModule'],
  spacing: [{
    paddingTop: 'lg',
    paddingBottom: 'lg'
  }, {}]
}];